// js/notifications.js
// Sistema de notificaciones, toasts y modales con estilos inline puros
function showNotification(message, type = 'info', duration = 4000) {
    // Crear contenedor si no existe
    let container = document.querySelector('[data-toast-container]');
    if (!container) {
        container = document.createElement('div');
        container.setAttribute('data-toast-container', '');
        container.style.cssText = `
            position: fixed;
            bottom: 1.5rem;
            right: 1.5rem;
            z-index: 99999;
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            pointer-events: none;
        `;
        document.body.appendChild(container);
    }

    // Crear toast
    const toast = document.createElement('div');
    const toastId = `toast-${Date.now()}`;
    
    let bgColor, borderColor, iconColor, icon;
    switch(type) {
        case 'success':
            bgColor = 'rgba(16, 185, 129, 0.15)';
            borderColor = 'rgba(16, 185, 129, 0.3)';
            iconColor = '#10b981';
            icon = '✓';
            break;
        case 'error':
            bgColor = 'rgba(239, 68, 68, 0.15)';
            borderColor = 'rgba(239, 68, 68, 0.3)';
            iconColor = '#ef4444';
            icon = '✕';
            break;
        case 'warning':
            bgColor = 'rgba(234, 179, 8, 0.15)';
            borderColor = 'rgba(234, 179, 8, 0.3)';
            iconColor = '#eab308';
            icon = '⚠';
            break;
        default: // info
            bgColor = 'rgba(59, 130, 246, 0.15)';
            borderColor = 'rgba(59, 130, 246, 0.3)';
            iconColor = '#3b82f6';
            icon = 'ⓘ';
    }
    
    toast.id = toastId;
    toast.style.cssText = `
        background: ${bgColor};
        border: 1px solid ${borderColor};
        border-radius: 0.5rem;
        padding: 1rem;
        backdrop-filter: blur(16px);
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        pointer-events: auto;
        animation: slideInUp 0.3s ease-out;
        max-width: 20rem;
    `;

    toast.innerHTML = `
        <span style="font-size: 1.25rem; color: ${iconColor}; flex-shrink: 0;">${icon}</span>
        <div style="display: flex; flex-direction: column; gap: 0.25rem;">
            <p style="font-size: 0.875rem; color: #f1f5f9; margin: 0;">${message}</p>
        </div>
        <button style="
            background: none;
            border: none;
            color: #94a3b8;
            cursor: pointer;
            padding: 0;
            margin-left: auto;
            font-size: 1.25rem;
            line-height: 1;
        " onclick="document.getElementById('${toastId}').remove();">×</button>
    `;

    container.appendChild(toast);

    if (duration > 0) {
        setTimeout(() => {
            toast.style.animation = 'slideOutDown 0.3s ease-in';
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }

    return toast;
}

// ========== ALERT MODAL (SAAS STYLE) ==========
function showAlert(title, message, type = 'info') {
    return new Promise((resolve) => {
        const backdrop = document.createElement('div');
        backdrop.style.cssText = `
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.5);
            backdrop-filter: blur(4px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99998;
            opacity: 0;
            transition: opacity 0.3s ease-out;
        `;

        let iconColor = '#3b82f6', icon = 'ⓘ';
        let bgGradient = 'linear-gradient(to right, #2563eb, #06b6d4)';
        
        switch(type) {
            case 'success':
                iconColor = '#10b981';
                icon = '✓';
                bgGradient = 'linear-gradient(to right, #10b981, #059669)';
                break;
            case 'error':
                iconColor = '#ef4444';
                icon = '✕';
                bgGradient = 'linear-gradient(to right, #ef4444, #dc2626)';
                break;
            case 'warning':
                iconColor = '#eab308';
                icon = '⚠';
                bgGradient = 'linear-gradient(to right, #eab308, #f59e0b)';
                break;
        }

        const modal = document.createElement('div');
        modal.style.cssText = `
            background: linear-gradient(to bottom right, #1e293b, #0f172a);
            border: 1px solid rgba(71, 85, 105, 0.3);
            border-radius: 1rem;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
            max-width: 28rem;
            width: 100%;
            margin: 0 1rem;
            overflow: hidden;
            transform: scale(0.95);
            opacity: 0;
            transition: all 0.3s ease-out;
        `;
        
        // Header
        const header = document.createElement('div');
        header.style.cssText = 'border-bottom: 1px solid rgba(71, 85, 105, 0.3); padding: 1.5rem; background: rgba(30, 41, 59, 0.5);';
        const headerInner = document.createElement('div');
        headerInner.style.cssText = 'display: flex; align-items: center; gap: 0.75rem;';
        const iconSpan = document.createElement('span');
        iconSpan.style.cssText = `font-size: 2rem; font-weight: bold; color: ${iconColor};`;
        iconSpan.textContent = icon;
        const titleH2 = document.createElement('h2');
        titleH2.style.cssText = 'font-size: 1.125rem; font-weight: 600; color: white; margin: 0;';
        titleH2.textContent = title;
        headerInner.appendChild(iconSpan);
        headerInner.appendChild(titleH2);
        header.appendChild(headerInner);
        
        // Body
        const body = document.createElement('div');
        body.style.cssText = 'padding: 1.5rem;';
        const msgP = document.createElement('p');
        msgP.style.cssText = 'font-size: 0.875rem; color: #cbd5e1; line-height: 1.5; margin: 0;';
        msgP.textContent = message;
        body.appendChild(msgP);
        
        // Footer with button
        const footer = document.createElement('div');
        footer.style.cssText = 'border-top: 1px solid rgba(71, 85, 105, 0.3); padding: 1rem 1.5rem; background: rgba(30, 41, 59, 0.1); text-align: right;';
        const okBtn = document.createElement('button');
        okBtn.className = 'alert-ok-btn';
        okBtn.style.cssText = `
            padding: 0.625rem 1.5rem;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: white;
            background: ${bgGradient};
            border: none;
            cursor: pointer;
            transition: opacity 0.2s ease;
        `;
        okBtn.textContent = 'Aceptar';
        footer.appendChild(okBtn);
        
        // Assemble modal
        modal.appendChild(header);
        modal.appendChild(body);
        modal.appendChild(footer);
        
        backdrop.appendChild(modal);
        document.body.appendChild(backdrop);

        // Trigger animations with a small delay
        setTimeout(() => {
            backdrop.style.opacity = '1';
            modal.style.transform = 'scale(1)';
            modal.style.opacity = '1';
        }, 10);

        const closeModal = () => {
            backdrop.style.opacity = '0';
            modal.style.transform = 'scale(0.95)';
            modal.style.opacity = '0';
            setTimeout(() => backdrop.remove(), 300);
        };

        okBtn.addEventListener('click', () => {
            closeModal();
            resolve(true);
        });
        okBtn.addEventListener('mouseover', () => {
            okBtn.style.opacity = '0.9';
        });
        okBtn.addEventListener('mouseout', () => {
            okBtn.style.opacity = '1';
        });

        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                closeModal();
                document.removeEventListener('keydown', handleEsc);
                resolve(false);
            }
        };
        document.addEventListener('keydown', handleEsc);

        backdrop.addEventListener('click', (e) => {
            if (e.target === backdrop) {
                closeModal();
                resolve(false);
            }
        });
    });
}

// ========== CONFIRM MODAL (SAAS STYLE) ==========
// Acepta tanto objeto {title, message, ...} como argumentos posicionales
function showConfirm(titleOrOptions, message, confirmText = 'Aceptar', cancelText = 'Cancelar', type = 'info') {
    // Soporte para sintaxis de objeto
    let title = titleOrOptions;
    let hideIcon = false;
    if (typeof titleOrOptions === 'object' && titleOrOptions !== null) {
        title = titleOrOptions.title || 'Confirmar';
        message = titleOrOptions.message || '';
        confirmText = titleOrOptions.confirmText || 'Aceptar';
        cancelText = titleOrOptions.cancelText || 'Cancelar';
        type = titleOrOptions.type || 'info';
        hideIcon = titleOrOptions.hideIcon || false;
    }
    
    return new Promise((resolve) => {
        const backdrop = document.createElement('div');
        backdrop.style.cssText = `
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.5);
            backdrop-filter: blur(4px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 99998;
            opacity: 0;
            transition: opacity 0.3s ease-out;
        `;

        let iconColor = '#3b82f6', iconSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';
        let bgGradient = 'linear-gradient(to right, #2563eb, #06b6d4)';
        
        switch(type) {
            case 'success':
                iconColor = '#10b981';
                iconSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
                bgGradient = 'linear-gradient(to right, #10b981, #059669)';
                break;
            case 'error':
                iconColor = '#ef4444';
                iconSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
                bgGradient = 'linear-gradient(to right, #ef4444, #dc2626)';
                break;
            case 'warning':
                iconColor = '#eab308';
                iconSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#eab308" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3.05h16.94a2 2 0 0 0 1.71-3.05L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';
                bgGradient = 'linear-gradient(to right, #eab308, #f59e0b)';
                break;
            case 'danger':
                iconColor = '#ef4444';
                iconSvg = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
                bgGradient = 'linear-gradient(to right, #ef4444, #dc2626)';
                break;
        }

        const modal = document.createElement('div');
        modal.style.cssText = `
            background: linear-gradient(to bottom right, #1e293b, #0f172a);
            border: 1px solid rgba(71, 85, 105, 0.3);
            border-radius: 1rem;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
            max-width: 28rem;
            width: 100%;
            margin: 0 1rem;
            overflow: hidden;
            transform: scale(0.95);
            opacity: 0;
            transition: all 0.3s ease-out;
        `;
        
        // Condicionar la visualización del icono
        const iconHTML = hideIcon ? '' : `${iconSvg}`;
        
        modal.innerHTML = `
            <div style="border-bottom: 1px solid rgba(71, 85, 105, 0.3); padding: 1.5rem; background: rgba(30, 41, 59, 0.5);">
                <div style="display: flex; align-items: center; gap: 0.75rem;">
                    ${iconHTML}
                    <h2 style="font-size: 1.125rem; font-weight: 600; color: white; margin: 0;">${title}</h2>
                </div>
            </div>
            
            <div style="padding: 1.5rem;">
                <p style="font-size: 0.875rem; color: #cbd5e1; line-height: 1.5; margin: 0;">${message}</p>
            </div>
            
            <div style="border-top: 1px solid rgba(71, 85, 105, 0.3); padding: 1rem 1.5rem; background: rgba(30, 41, 59, 0.1); display: flex; gap: 0.75rem; justify-content: flex-end;">
                <button class="confirm-cancel-btn" style="
                    padding: 0.625rem 1.5rem;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                    color: #cbd5e1;
                    background: transparent;
                    border: 1px solid rgba(71, 85, 105, 0.5);
                    cursor: pointer;
                    transition: all 0.2s ease;
                ">
                    ${cancelText}
                </button>
                <button class="confirm-ok-btn" style="
                    padding: 0.625rem 1.5rem;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                    color: white;
                    background: ${bgGradient};
                    border: none;
                    cursor: pointer;
                    transition: opacity 0.2s ease;
                ">
                    ${confirmText}
                </button>
            </div>
        `;

        backdrop.appendChild(modal);
        document.body.appendChild(backdrop);

        // Trigger animations with a small delay
        setTimeout(() => {
            backdrop.style.opacity = '1';
            modal.style.transform = 'scale(1)';
            modal.style.opacity = '1';
        }, 10);

        const closeModal = () => {
            backdrop.style.opacity = '0';
            modal.style.transform = 'scale(0.95)';
            modal.style.opacity = '0';
            setTimeout(() => backdrop.remove(), 300);
        };

        const okBtn = modal.querySelector('.confirm-ok-btn');
        const cancelBtn = modal.querySelector('.confirm-cancel-btn');

        okBtn.addEventListener('click', () => {
            closeModal();
            resolve(true);
        });
        okBtn.addEventListener('mouseover', () => {
            okBtn.style.opacity = '0.9';
        });
        okBtn.addEventListener('mouseout', () => {
            okBtn.style.opacity = '1';
        });

        cancelBtn.addEventListener('click', () => {
            closeModal();
            resolve(false);
        });
        cancelBtn.addEventListener('mouseover', () => {
            cancelBtn.style.backgroundColor = 'rgba(71, 85, 105, 0.3)';
        });
        cancelBtn.addEventListener('mouseout', () => {
            cancelBtn.style.backgroundColor = 'transparent';
        });

        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                closeModal();
                document.removeEventListener('keydown', handleEsc);
                resolve(false);
            }
        };
        document.addEventListener('keydown', handleEsc);

        backdrop.addEventListener('click', (e) => {
            if (e.target === backdrop) {
                closeModal();
                resolve(false);
            }
        });
    });
}

// ========== LOADING MODAL ==========
function showLoading(title = 'Cargando', message = '') {
    const backdrop = document.createElement('div');
    backdrop.style.cssText = `
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99997;
        animation: fadeIn 0.3s ease-out;
    `;

    const modal = document.createElement('div');
    modal.style.cssText = `
        background: linear-gradient(to bottom right, #1e293b, #0f172a);
        border: 1px solid rgba(71, 85, 105, 0.3);
        border-radius: 1rem;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
        max-width: 28rem;
        width: 100%;
        margin: 0 1rem;
        overflow: hidden;
        animation: scaleIn 0.3s ease-out;
    `;

    modal.innerHTML = `
        <div style="padding: 2rem; display: flex; flex-direction: column; align-items: center; gap: 1rem;">
            <div style="position: relative; width: 3rem; height: 3rem;">
                <div style="
                    position: absolute;
                    inset: 0;
                    border: 4px solid rgba(71, 85, 105, 0.3);
                    border-top-color: #3b82f6;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                "></div>
            </div>
            <div style="text-align: center;">
                <h2 style="font-size: 1.125rem; font-weight: 600; color: white; margin: 0;">${title}</h2>
                ${message ? `<p style="font-size: 0.875rem; color: #cbd5e1; margin-top: 0.5rem; margin-bottom: 0;">${message}</p>` : ''}
            </div>
        </div>
    `;

    backdrop.appendChild(modal);
    document.body.appendChild(backdrop);

    return backdrop;
}

function closeLoading(backdrop) {
    if (backdrop) {
        backdrop.style.animation = 'fadeOut 0.3s ease-in';
        setTimeout(() => backdrop.remove(), 300);
    }
}

// ========== EXPOSE TO WINDOW ==========
// Guardar referencias internas PRIMERO para evitar recursion circular con config.js
window._notificationsShowNotification = showNotification;
window._notificationsShowAlert = showAlert;
window._notificationsShowConfirm = showConfirm;

// Hacer las funciones disponibles globalmente
window.showNotification = showNotification;
window.showAlert = showAlert;
window.showConfirm = showConfirm;
window.showError = function(message, duration = 4000) {
    return showNotification(message, 'error', duration);
};
window.showWarning = function(title, message) {
    return showAlert(title, message, 'warning');
};
window.showSuccess = function(message, duration = 4000) {
    return showNotification(message, 'success', duration);
};
window.showInfo = function(title, message) {
    return showAlert(title, message, 'info');
};
window.showLoading = showLoading;
window.closeLoading = closeLoading;
